<template>
	<div class="content flex flex-align-start">
		<div class="flex-1 mr40">
			<el-form ref="form" label-width="90px" class="inline-form" style="height: 45px;">
				<el-form-item label="学历类别：" class="inline-item1">
					<el-radio-group v-model="radio" @change="handleRadioChange">
						<el-radio :label="index" v-for="(item,index) in types" :key="index">{{ item.text }}</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="岗位类别：" v-if="radio == 1" class="inline-item1">
					<el-radio-group v-model="position" @change="handlePositionChange">
						<el-radio :label="index" v-for="(item,index) in positions" :key="index">{{ item.text }}</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="省份：" v-if="radio == 1 && position == 1" class="inline-item1">
					<el-select class="ml5 province-select" size="small" @change="handleProvinceChange" v-model="province" filterable placeholder="请选择" :disabled="!userInfo.vip" :loading="!isReady">
				    	<el-option v-for="(item,index) in provinceList" :key="index" :label="item" :value="item"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			
			<div style="margin-top: 10px;">
				<div style="width: 500px;float:left;">
					<el-input placeholder="请输入内容" v-model="desc" :disabled="radio == 1 && position == 1 && !province" class="input-with-select" @keyup.enter.native="search()">
						<template slot="prepend">专业名称</template>
						<el-button slot="append" icon="el-icon-search" :loading="loading" @click="search()"></el-button>
					</el-input>
				</div>
				<div class="ml10" style="float:right;" v-if="radio==1">
					<!-- <span class="mr10" style="line-height: 40px;">对比数量：<span style="color: red;">【{{compareNumber}}】</span></span> -->
					<el-badge :value="compareNumber" class="item">
						<el-button :disabled="compareNumber==0" size="small" type="primary" @click="startCompare">开始对比</el-button>
					</el-badge>
					<el-button :disabled="compareNumber==0" style="margin-left: 20px;" size="small" type="info" @click="clearCompare">清空对比</el-button>
				</div>
			</div>
			<div style="clear: both;"></div>
			<!-- 展示分类区域开始 -->
			<div class="mt10 px15 py15" v-if="radio == 1" style="border:1px solid #DCDFE6">
				<el-form ref="form" label-width="90px" class="inline-form">
					<el-form-item label="专业门类：" class="inline-item1">
						<el-radio-group v-model="big" class="radio-group-wrap" @change="handleRadioBigChange">
							<el-radio :label="item.text" v-for="(item,index) in bigClass" :key="index">{{ item.text }}</el-radio>
						</el-radio-group>
					</el-form-item>
				</el-form>
				<el-form ref="form" v-if="big!='全部'" label-width="90px" class="inline-form">
					<el-form-item label="专业类：" class="inline-item1">
						<el-radio-group v-model="small" class="radio-group-wrap" @change="handleRadioSmallChange">
							<el-radio :label="item.text" v-for="(item,index) in smallClass" :key="index">{{ item.text }}</el-radio>
						</el-radio-group>
					</el-form-item>
				</el-form>
			</div>
			<!-- 展示分类区域结束 -->

			<!-- 展示搜索结果区域开始 -->
			<div class="mt30" v-show="isReady && tableHeader.length && radio==0">
				<!-- table -->
				<el-table :data="listZY" v-loading="isLoading" border style="width: 100%" :header-cell-style="{ backgroundColor: '#f5f7fa', color: '#000000', fontSize: '16px' }">
				    <el-table-column :prop="'col' + index" :label="item" align="center" :width="item == '专业名称'?'200':''" v-for="(item,index) in tableHeader" :key="index"></el-table-column>
					
					<!-- 暂无数据 -->
					<template #empty>
						<el-empty description="暂无数据" :image-size="120"></el-empty>
					</template>
				</el-table>
				
				<!-- 分页 -->
				<div class="mt20" v-if="listZY.length">
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page" :page-sizes="pageSizeArr" :page-size="page_size" layout="total, sizes, prev, pager, next, jumper" :total="totalCount"></el-pagination>
				</div>
			</div>

			<div v-if="radio==1">
				<div class="mt30" v-if="big!='全部'">
					<span class="fwb f20 pointer" @click="majorStartCompare(big)" style="border-left: 3px solid #00a1ff;padding-left: 8px;">{{ big }}</span>
				</div>
				<div class="mt15" v-if="big!='全部'" style="border-bottom: 1px solid #DCDFE6;"></div>
				<div class="mt30" v-if="small!='全部'">
					<span class="border fwb pointer" @click="majorStartCompare(small)">{{ small }}</span>
				</div>
				<div :class="small == '全部'?'mt20': 'mt9'" class="px15 py5" style="border:1px solid #DCDFE6" v-show="list.length>0 && radio==1">
					<div class="h40 mt10" v-for="(item,index) in list" :key="index" :style="{ 'border-bottom': index === list.length - 1 ? '1px solid #DCDFE6' : '1px solid #DCDFE6' }">
						<span class="float-l" style="line-height: 40px;">
							<el-button type="text" @click="majorStartCompare(item.stuMajor)">
								<span style="color: black;">{{ item.stuMajor }}</span>
							</el-button>
						</span>
						<span class="float-r" v-if="radio==1 && (position==0 || (position==1 && province))">
							<el-button size="small" type="success" @click="addCompare(item)">加入对比</el-button>
						</span>
					</div>
					<!-- 分页 -->
					<div class="mt20" v-if="list.length">
						<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page" :page-sizes="pageSizeArr" :page-size="page_size" layout="total, sizes, prev, pager, next, jumper" :total="totalCount"></el-pagination>
					</div>
				</div>
				<div v-show="list.length<=0 && radio==1">
					<el-empty description="暂无数据" :image-size="120"></el-empty>
				</div>
			</div>
			<!-- 展示搜索结果区域结束 -->
		</div>
		
		<!-- 宣传图 -->
		<div class="sticky" style="top: 200px;">
			<el-carousel class="border-radius-10" style="width: 360px;" trigger="click" :interval="5000" arrow="never" height="480px">
				<el-carousel-item v-for="(item,index) in swiper" :key="index">
					<el-image style="width: 360px;height: 480px;" :src="item.image" fit="cover"></el-image>
				</el-carousel-item>
			</el-carousel>
		</div>
	</div>
</template>

<script>
import { EventBus } from '@/main.js'
export default {
	name: 'CheckJob',
	data(){
		return{
			compareNumber: 0,// 对比数量
			provinceList: [],
			province: '',
			cgwMajorGroupsList: [],
			big: '全部',
			bigClass: [
				{ text: '全部', type: '0' },
			],
			small: '全部',
			smallClass: [
			],
			types: [
				{ text: '专科', type: 'GW_ZK' },
				{ text: '本科及以上', type: 'GW_BK' },
			],
			positions: [
				{ text: '公务员国考', type: 'GW_BK_GK' },
				{ text: '公务员省考', type: 'GW_BK_SK' },
			],
			radio: 1,
			position: 0,
			desc: '',
			
			loading: false,  // 搜索按钮loading
			tableHeader: [],  // 表头
			list: [],
			listZY: [],
		}
	},
	mounted(){
		EventBus.$emit('router-path', this.$route.path)
		// 查询省份信息
		this.getProvince()
		// 查询专业大类、专业类
		this.getCgwMajorGroups()
	},
	methods: {
		async getProvince(){
			this.$http.get('/api/webs/search/cgwBkSkProvince').then(response => {
				let res = response.data
				this.isReady = true
				if(res!=null){
					this.provinceList = res.list
				}
			})
			.catch(error => {
				console.error(error)
			})
		},
		async getCgwMajorGroups(){
			this.$http.get('/api/webs/search/cgwMajorGroups').then(response => {
				this.cgwMajorGroupsList = response.data.list;
				var index = 1;
				this.cgwMajorGroupsList.forEach(item => {
				    this.bigClass.push({ text: item.majorTop, type: index });
					index++;
				})
			})
			.catch(error => {
				console.error(error)
			})
		},

		search(){
			if(!this.token) return EventBus.$emit('show-login', true)
			if(!this.desc) return this.$message({ message: '请输入专业名称', type: 'warning' })
			this.loading = true
			this.isReady = false
			this.big = '全部'
			this.small = '全部'
			this.getData()
		},
		
		handleSizeChange(val) {
			this.page_size = val
			this.isLoading = true
			this.getData()
		},
		handleCurrentChange(val) {
			this.page = val
			this.isLoading = true
			this.getData()
		},
		
		async getData(){
			let params = {
				pageNum: this.page,
				pageSize: this.page_size,
				// type: this.types[this.radio].type,
				// majorNameLike: this.desc
			}
			if(this.big!='全部'){
				params.stuMajorTop= this.big;
			}
			if(this.small!='全部'){
				params.stuMajorGroup= this.small;
			}
			var method='/api/webs/search/cgwMajor';
			if(this.radio==0){
				this.listZY = []
				params.type = 'GW_ZK';
				method = '/api/webs/search/cgw'
				params.nameLike= this.desc;
			} else {
				params.majorNameLike= this.desc;
				this.list = []
			}
			this.$http.get(method, { params }).then(response => {
				let res = response.data
				this.loading = false
				this.isLoading = false
				this.isReady = true
				
				this.totalCount = res.total
				if(this.radio==0){
					this.tableHeader = res.data.header
					this.listZY = res.list
				} else {
					this.list = res.list
				}
			})
			.catch(error => {
				console.error(error)
				this.loading = false
				this.isLoading = false
			})
		},
		// 选择学历类别事件
		handleRadioChange(selectedValue){
			// this.list = [];
			this.desc = '';
			// 本科及以上查询缓存中对比数量
			if(selectedValue==1){
				this.getCompareNumber();
			}
		},
		// 选择岗位类别事件
		handlePositionChange(selectedValue){
			this.desc = '';
			this.getCompareNumber();
		},
		// 选择省份事件
		handleProvinceChange(selectedValue){
			this.getCompareNumber();
		},
		// 选择专业大类事件
		handleRadioBigChange(selectedValue){
			this.smallClass = [{ text: '全部', type: '0' }];
			this.small = '全部';
			var index = 1;
			this.cgwMajorGroupsList.forEach(item => {
				if(item.majorTop==selectedValue){
				    item.majorGroupList.forEach(item => {
						this.smallClass.push({ text: item, type: index });
				    })
				}
			})
			this.getDataByClass();
		},
		// 选择专业类事件
		handleRadioSmallChange(selectedValue){
		    this.getDataByClass();
		},
		async getDataByClass(){
			let params = {
				pageNum: this.page,
				pageSize: this.page_size,
			}
			if(this.big!='全部'){
				params.stuMajorTop= this.big;
			}
			if(this.small!='全部'){
				params.stuMajorGroup= this.small;
			}
			this.list = []
			this.$http.get('/api/webs/search/cgwMajor', { params }).then(response => {
				let res = response.data
				this.loading = false
				this.isLoading = false
				this.isReady = true
				
				this.totalCount = res.total
				this.list = res.list
			})
			.catch(error => {
				console.error(error)
				this.loading = false
				this.isLoading = false
			})
		},
		// 查询缓存中的对比数据
		getCompareNumber(){
			if(this.position==0){
				// 国考
				var data = localStorage.getItem('countryCompareData');
				if(data){
					this.compareNumber = JSON.parse(data).length;
				} else {
					this.compareNumber = 0;
				}
			} else if(this.position==1 && this.province!=''){
				// 省考
				var data = localStorage.getItem(this.province+'provinceCompareData');
				if(data){
					this.compareNumber = JSON.parse(data).length;
				} else {
					this.compareNumber = 0;
				}
			} else {
				this.compareNumber = 0;
			}
		},
		// 加入对比
		addCompare(item){
			if(this.position==0){
				// 国考
				let storedData = localStorage.getItem('countryCompareData');
				let dataArray = [];
				// 如果已有数据，则解析为数组
				if (storedData) {
					dataArray = JSON.parse(storedData);
				}
				// 往数组中添加新数据
  				dataArray.push(item.stuMajor);
				dataArray = [...new Set(dataArray)]; // 简单值去重
				// 重新存入localStorage
				localStorage.setItem('countryCompareData', JSON.stringify(dataArray));
				// 更新当前组件中的计数
				this.compareNumber = dataArray.length;
			} else if(this.position==1){
				// 省考
				let storedData = localStorage.getItem(this.province+'provinceCompareData');
				let dataArray = [];
				// 如果已有数据，则解析为数组
				if (storedData) {
					dataArray = JSON.parse(storedData);
				}
				// 往数组中添加新数据
  				dataArray.push(item.stuMajor);
				dataArray = [...new Set(dataArray)]; // 简单值去重
				// 重新存入localStorage
				localStorage.setItem(this.province+'provinceCompareData', JSON.stringify(dataArray));
				// 更新当前组件中的计数
				this.compareNumber = dataArray.length;
			}
		},
		// 点击查出来的单个专业，开始对比
		majorStartCompare(stuMajor){
			localStorage.removeItem('CompareData');
			let dataArray = [];
			dataArray.push(stuMajor);
			localStorage.setItem('CompareData', JSON.stringify(dataArray));
			var type='GW_ZK';
			if(this.radio==0){
			    type='GW_ZK';
			} else {
				if(this.position==0){
					type='GW_BK_GK';
				} else {
					type='GW_BK_SK';
				}
			}
			this.$router.push('/major-compare?type='+type+'&province='+this.province)
		},
		// 开始对比
		startCompare(){
			if(this.position==0){
				// 国考
				var data = localStorage.getItem('countryCompareData');
				localStorage.removeItem('CompareData');
				localStorage.setItem('CompareData', data);
			} else if(this.position==1 && this.province!=''){
				// 省考
				var data = localStorage.getItem(this.province+'provinceCompareData');
				localStorage.removeItem('CompareData');
				localStorage.setItem('CompareData', data);
			}
			var type='GW_ZK';
			if(this.radio==0){
			    type='GW_ZK';
			} else {
				if(this.position==0){
					type='GW_BK_GK';
				} else {
					type='GW_BK_SK';
				}
			}
			this.$router.push('/major-compare?type='+type+'&province='+this.province)
		},
		// 清空对比
		clearCompare(){
			if(this.position==0){
				// 国考
				localStorage.removeItem('countryCompareData');
			} else if(this.position==1){
				// 省考
				localStorage.removeItem(this.province+'provinceCompareData');
			}
			this.compareNumber = 0;
		},
	}
}
</script>

<style scoped>
.el-form-item{
	margin-bottom: 0 !important;
}
.el-input--suffix{
	width: 110px !important;
}
/* 容器使用Flex布局 */
.inline-form {
  display: flex;
  align-items: center; /* 垂直居中对齐 */
  flex-wrap: wrap; /* 超出时自动换行，避免溢出 */
  gap: 5px; /* 项目之间的间距 */
}
/* 隐藏单选框的圆圈 */
:deep(.el-radio__input) {
  display: none;
}
:deep(.el-radio__label) {
  padding-left: 0px;
}
/* 单选框之间的间距 */
:deep(.el-radio) {
  margin-right: 20px;
}
/* 省份选择器宽度 */
.province-select {
  width: 160px; /* 根据需要调整宽度 */
}

/* 单选框组容器样式 */
.radio-group-wrap {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap; /* 允许单选框换行 */
  gap: 15px 0px; /* 水平间距20px，垂直间距15px */
  padding: 5px 0; /* 增加内边距，避免内容贴边 */
}
.border{
	border-top: 1px solid #DCDFE6; 
	border-left: 1px solid #DCDFE6; 
	border-right: 1px solid #DCDFE6; 
	border-bottom: 1px solid white; 
	padding: 10px;
	background-color: white;
	color: #00a1ff;
}
</style>